import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { HeaderList } from "../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { BranchService } from "../../services/branch.service";
import { BranchModel } from "../../models/branch.model";
import { EquipmentModel } from "../../models/equipment.model";
import { EquipmentService } from "../../services/equipment.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../models/requestInputOutputParams.model";
import { HeadDateModel } from "../../models/headDate.model";
import { EventExportService } from "../../services/eventExport.service";
import { ForeCastService } from "../../services/forecast.service";
import storageService from "../../services/storage.service";
import UtilService from "../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import { faSortAlphaUp, faSortAlphaDown, faSort } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../services/helper.service";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../components/buttons";
import Pagination, { IPag, IPagination } from "../../components/Pagination";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GroupModel } from "../../models/group.model";
import GroupService from "../../services/group.service";
import { ModalApprover } from "./components/Modal";
import DashboardService from "../../services/dashboard.service";
import { ToastService } from "../../services/toast.service";
import DashboardBranchService from "../../services/dashboardBranch.service";

import './styles.css';

function Table({ columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];

  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style: React.CSSProperties = {
      border: 'none',
      color: '#2196F3',
      fontWeight: 700,
      textAlign: 'center',
      paddingLeft: '10px',
      width: cellInfo?.column?.width,
    };
    if (cellInfo?.id === 'justification' || cellInfo?.id === 'user_fullname') {
      style.textAlign = 'left';
    }
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style: React.CSSProperties = {
      width: cellInfo.column.width,
      height: '100%',
      padding: 2,
      textAlign: 'center',
      paddingLeft: '10px',
      wordBreak: 'break-word', // Garante quebra de linha no texto longo
      overflow: 'hidden' // Oculta o texto que ultrapassa o limite da célula
    };
    if (cellInfo?.column?.id === 'justification' || cellInfo?.column?.id === 'user_fullname') {
      style.textAlign = 'left';
    }

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <div style={{ overflowX: 'auto' }}>
      <BTable hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.filter(x => !x.columns).map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={formatCellStyleHeader(column)}
                >
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "table-caption" }}>
                      {column.render('Header')}
                    </div>
                    {column.canSort
                      ? column.isSorted
                        ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                        : <FontAwesomeIcon icon={faSort} />
                      : null
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            const isUpdated = row.original.isUpdated;
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {

                  if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                    return <td
                      colSpan={7}
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {msgEmpty}
                      </div>
                    </td>
                  }

                  if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                    return <></>;
                  }
                  return (
                    <td
                      {...cell.getCellProps()}

                    >
                      <div style={formatCellStyle(cell)}>
                        {cell.render('Cell')}
                      </div>
                    </td>
                  )
                }
                )}
              </tr>
            )
          })}
        </tbody>
      </BTable>
    </div>
  );
}

const ApproverPickupMinList = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();

  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_pending_equipment_pickup_approval',
    filters: {
      branch_id: [],
      code_equipment: [],
      date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      date_end: moment().add(7, 'days').format('YYYY-MM-DD')
    },
    parameters: {}
  });

  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_pending_equipment_pickup_approval',
    filters: {
      branch_id: [],
      code_equipment: [],
      date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      date_end: moment().add(7, 'days').format('YYYY-MM-DD')
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });


  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [branches, setBranches] = useState<BranchModel[]>();
  const [codeEquipment, setCodeEquipment] = useState<string>();
  const [group, setGroup] = useState<GroupModel[]>();

  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setRejectModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);


  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      //pagination.page_number = dataTable?.page_number;
      //pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters
    }

    const response: any = await ForeCastService.pendingEquipmentPickupApproval(requestParams);
    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'report_pending_equipment_pickup_approval' }));
      setDatasetDashboardAnalytical(d);
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };

  const initialize = async () => {
    BranchService.getAllList().then((response: any) => {
      if (response.success) {
        let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'branch' });
        if (branchList[0].data != null) {
          const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
          setBranches(sort);
        }
        else
          setBranches([]);
      } else {
        setBranches([]);
      }
    });

    GroupService.getAll().then((response: any) => {
      if (response.success) {
        let groupList = response.result;
        const sort = groupList.sort((a, b) => a.fullName.localeCompare(b.fullName)).filter(t => t.inconsistentForecastAnalysis === true);
        setGroup(sort);
      } else {
        setGroup([]);
      }
    });

    await getList({
      page_number: 1
    })
  };

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [, datasetDashboardAnalytical?.data, selectedDataDashboard]);

  const [loadingRowId, setLoadingRowId] = useState(null); // Mantém o ID da linha que está em loading
  const [isLoadingApprove, setIsLoadingApprove] = useState(false); // Para aprovação
  const [isLoadingReject, setIsLoadingReject] = useState(false);   // Para rejeição


  const columns = React.useMemo(
    () => [
      {
        Header: t("INCONSISTENT.EQUIPMENT"),
        background: '#4b4b50',
        columns: [
          {
            Header: () => (<span>{t("ACTIONS")}</span>),
            accessor: "actions",
            background: '#999999',
            disableSortBy: true,
            width: 200,
            Cell: ({ row }) => (
              <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                 <button
                  onClick={() => handleApprove(row.original)}
                  style={{
                    backgroundColor: isLoading ? '#cccccc' : '#007bff', // Cinza quando em loading
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '0px 10px',
                    cursor: loadingRowId === row.original.id ? 'not-allowed' : 'pointer',// Desabilita clique quando em loading
                  }}
                  disabled={loadingRowId === row.original.id || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} // Desabilita botão durante o loading
                >
                   {loadingRowId === row.original.id ? t("LOADING") : t("BUTTONS.APPROVE")} {/* Exibe "LOADING" enquanto em progresso */}
                </button>
                <button
                  onClick={() => handleReject(row.original)}
                  style={{
                    backgroundColor: isLoading ? '#cccccc' : '#dc3545', // Cinza quando em loading
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '5px 10px',
                    cursor: loadingRowId === row.original.id ? 'not-allowed' : 'pointer',// Desabilita clique quando em loading
                  }}
                  disabled={loadingRowId === row.original.id || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} // Desabilita botão durante o loading
                >
                   {loadingRowId === row.original.id ? t("LOADING") : t("BUTTONS.REJECT")} {/* Exibe "LOADING" enquanto em progresso */}
                </button>
              </div>
            ),
          },          
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.BRANCH")}</span>),
            accessor: "regional",
            background: '#999999',
            disableSortBy: true,
            width: 50,
            Cell: props => (props.value)
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.EQUIPMENT")}</span>),
            accessor: "code_equipment",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)
          },

          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.DAY_OF_WEEK")}</span>),
            accessor: "day_of_week",
            background: '#999999',
            disableSortBy: true,
            width: 100,
            Cell: props => t(props.value.toUpperCase())
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.FORECAST_VALUE")}</span>),
            accessor: "current_forecast_value",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (formatToCurrency(props.value))           
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE_PHYSICAL")}</span>),
            accessor: "selected_collection_percentage",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)           
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE_PHYSICAL_IDEAL")}</span>),
            accessor: "monetary_limit_div_limit_contractual",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)              
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.FORECAST_VALUE_PHYSICAL")}</span>),
            accessor: "current_forecast_value_physical",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)             
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE_PHYSICAL")}</span>),
            accessor: "selected_collection_percentage_physical",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)          
          },
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE_PHYSICAL_IDEAL")}</span>),
            accessor: "monetary_limit_div_limit_contractual_physical",
            background: '#999999',
            disableSortBy: true,
            width: 80,
            Cell: props => (props.value)
          },          
          {
            Header: () => (<span>{t("COLLECTION_SCHEDULE.USER_NAME")}</span>),
            accessor: "user_fullname",
            background: '#999999',
            disableSortBy: true,
            width: 150,
            Cell: props => {
              // Função para pegar os dois primeiros nomes
              const getFirstTwoNames = (fullName) => {
                if (!fullName) return '';
                const names = fullName.split(' ');
                return names.slice(0, 2).join(' ');
              };

              return getFirstTwoNames(props.value);
            }
          },
          {
            Header: () => <span>{t("COLLECTION_SCHEDULE.JUSTIFICATION")}</span>,
            accessor: "justification",
            background: '#999999',
            disableSortBy: true,
            width: 650,
            Cell: ({ value }) => {
              // Define o limite de caracteres
              const maxLength = 80;
          
              // Checa se o texto é maior que o limite
              const isLongText = value && value.length > maxLength;
          
              // Trunca o texto para o limite especificado e adiciona reticências
              const truncatedText = isLongText ? value.slice(0, 77) + '...' : value;
          
              // Renderiza o Tooltip apenas quando necessário
              const renderTooltip = (props) => (
                <Tooltip id="tooltip" {...props} className="custom-tooltip">
                  {value}
                </Tooltip>
              );
          
              // Renderiza com OverlayTrigger apenas se for um texto longo
              return isLongText ? (
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <span style={{ cursor: 'pointer' }}>
                    {truncatedText}
                  </span>
                </OverlayTrigger>
              ) : (
                <span>{truncatedText}</span>
              );
            }
          }
        ]
      },
    ],
    []
  );

  const handleApprove = (row) => {
    console.log(`Aprovar: ${JSON.stringify(row)}`);
    setSelectedRow(row);
    setApproveModalOpen(true); // Open the approve modal
  };

  const handleReject = (row) => {
    console.log(`Reprovar: ${JSON.stringify(row)}`);
    setSelectedRow(row);
    setRejectModalOpen(true); // Open the reject modal
  };

  const handleCloseModal = () => {
    setApproveModalOpen(false);
    setRejectModalOpen(false);
    setSelectedRow(null); // Clear selected row when closing modal
  };

  const [disableButtons, setDisableButtons] = useState(false); // Bloqueia múltiplos cliques


  const handleConfirmApprove = async () => {
    if (disableButtons || !selectedRow) return; // Evita múltiplos cliques

    setDisableButtons(true); // Desativa cliques extras
    setLoadingRowId(selectedRow.id);
    setIsLoadingApprove(true);

    try {
        console.log(`Aprovado: ${JSON.stringify(selectedRow)}`);
        await sendSelectedDay(selectedRow, true); // Aguarda a API retornar

        // **Garante que os botões só serão reativados após a API finalizar**
        await getList({ page_number: 1 });

    } catch (error) {
        console.error("Erro ao aprovar:", error);
    } finally {
        setLoadingRowId(null); // Só ativa o botão depois de atualizar a tabela
        setIsLoadingApprove(false);
        setDisableButtons(false);
        handleCloseModal(); // Fecha o modal apenas depois de tudo ser concluído
    }
};

const handleConfirmReject = async () => {
    if (disableButtons || !selectedRow) return;

    setDisableButtons(true);
    setLoadingRowId(selectedRow.id);
    setIsLoadingReject(true);

    try {
        console.log(`Reprovado: ${JSON.stringify(selectedRow)}`);
        await sendSelectedDay(selectedRow, false);

        await getList({ page_number: 1 });

    } catch (error) {
        console.error("Erro ao rejeitar:", error);
    } finally {
        setLoadingRowId(null);
        setIsLoadingReject(false);
        setDisableButtons(false);
        handleCloseModal();
    }
};


  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };
  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [datasetDashboardCore, setDatasetDashboardCore] =
    useState<DatasetModel>({
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: "dashboard_core",
      filters: {
        locale_id: [],
        transporter_id: [],
        branch_id: [],
        is_pickup: null,
        is_event: null,
        is_danger: null,
        code_equipment: [],
        customer: [],
        multiclient: [],
        monit_equipment: [],
        equipment_imposition: [],
      },
      sort: {
        field: "code_equipment",
        orientation: "asc",
      },
    });

  const sendSelectedDay = async (row, isApproved) => {
    setLoadingRowId(row.id); // Define a linha que está em loading
    setLoading(true);


    // Atualizar os dados com base no selectedRow
    const updatedData = {
      id_equipment: row.equipment_id || null, // Caso não exista
      code_equipment: row.code_equipment || "",
      day_name: row.day_name || "",
      pickup_date: row.programming_date || "",
      flag_pickup_physical_limit: row.flag_pickup_physical_limit || false,
      flag_pickup_monetary_limit: row.flag_pickup_monetary_limit || false,
      total_amount_collect_pickup_physical_limit: row.total_amount_collect_pickup_physical_limit || 0,
      total_amount_collect_pickup_monetary_limit: row.total_amount_collect_pickup_monetary_limit || 0,
      is_checked_prog_status: true, // Define como true
      contractual_limit_value: row.contractual_limit_value || 0,
      selected_collection_percentage: row.selected_collection_percentage || 0,
      justification: row.justification || "",
      is_programming_approved: true, // Define como true
      daysOfWeek: row.daysOfWeek || "",
      decision_programming: isApproved,

      monetary_limit_div_limit_contractual: row.monetary_limit_div_limit_contractual || 0,
      monetary_limit_div_limit_contractual_physical: row.monetary_limit_div_limit_contractual_physical || 0,
      id_minimum_value_pickup_justify: row.id_minimum_value_pickup_justify,
    };

    const dataSend = {
      datasets: [
        {
          dataset: "dashboard_core_pickup",
          data: [updatedData] // Enviar como um array
        },
      ],
      parameters: { date_begin: moment().format("yyyy-MM-DD") },
    };
    
    DashboardService.equipmentPickup(dataSend)
      .then((response: any) => {
        if (response && response.success) {
          let respData = _.last(
            _.filter(response.result.datasets, { dataset: "dashboard_core" })
          );
          let dataActual = _.clone(datasetDashboardCore);

          /* _.map(respData?.data, data => {
            let idxDataSended = _.findIndex(dataActual.data, {
              idEquipment: data.idEquipment,
            });
            dataActual.data[idxDataSended] = data;
          }); */

          setSelectedDataDashboard(null);
          setDatasetDashboardCore(dataActual);
          //handleCloseModal();
          ToastService.success(
            `Decisão da programação: ${
              isApproved ? "Aprovação" : "Rejeição"
            } bem-sucedida!`
          );
          // handleCloseModal();
        }
      })
      .finally(() => {
        setLoadingRowId(null); // Remove o loading da linha atual
        setLoading(false);
        getList({ page_number: 1 });

        // Atrasar a execução de saveEquipmentProgram em 30 segundos
        if (isApproved) {
          setTimeout(async () => {
            await saveEquipmentProgram(updatedData);
          }, 10000); // 30000 milissegundos = 30 segundos
        }
         // Fecha o modal somente após o término do processo
          // handleCloseModal();
      });

  };

  const saveEquipmentProgram = async (updatedData) => {
    setLoading(true);

    // Usa os valores de updatedData para criar o pickupStatusData
    const pickupStatusData = {
      id_equipment: updatedData.id_equipment,
      pickup_date: updatedData.pickup_date,
      dash_action: "PROGRAM",
      pickup_change_required: false // Sempre falso
    };

    let requestParams = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [{
        ...DatasetDefault,
        dataset: 'dashboard_branch_pickupstatus',
        data: [pickupStatusData] // Envia como um array
      }]
    };

    try {
      const response = await DashboardBranchService.updateEquipmentPickupStatus(requestParams);

      if (response.success === true && response.result) {
        const dataset = _.last(_.filter(response.result.datasets, { dataset: "dashboard_branch" }));

        if (dataset?.data) {
          for (let i = 0; i < dataset.data.length; i++) {
            //updateCardByData(dataset.data[i]);
          }
        }
       // ToastService.success(t('DASHBOARD_BRANCH.SCHEDULE_SUCCESS'));
      }
    } finally {
      //setCardSelecteds([]);
      setLoading(false);
      // handleCloseModal();
    }
  };

  return (
    
    <>
      {/* Modal de Aprovação */}
      <ModalApprover
        isOpen={approveModalOpen}
        onClose={isLoadingApprove ? null : handleCloseModal}
        onConfirm={handleConfirmApprove}
        onReject={handleConfirmReject}
        Title={t("TITLE_MODAL_APPROVE_PICKUP_MINIMUM")}
        ButtonCloseLabel={t("CANCEL")}
        ButtonConfirmLabel={t("BUTTONS.APPROVE")}
        showRejectButton={false} // Only show reject button in reject modal
        Mensagem={t("MSG_APPROVE_PICKUP_MINIMUM")}
        isLoading={isLoadingApprove} // Passa o estado de loading para desativar os botões
      />

      {/* Modal de Rejeição */}
      <ModalApprover
        isOpen={isRejectModalOpen}
        onClose={isLoadingReject ? null : handleCloseModal}
        onConfirm={handleConfirmReject}
        Title={t("TITLE_MODAL_REJECT_PICKUP_MINIMUM")}
        ButtonCloseLabel={t("CANCEL")}
        ButtonConfirmLabel={t("BUTTONS.REJECT")}
        ButtonRejectLabel="" // No reject button for reject modal
        showRejectButton={false} // Only show reject button in reject modal
        Mensagem={t("MSG_REJECT_PICKUP_MINIMUM")}
        isLoading={isLoadingReject} // Passa o estado de loading para desativar os botões
      />

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <HeaderList title={t(`INCONSISTENT.TITLE_APPROVE_PICKUP_MIN`)} />
      </div>

      <Row className="align-items-center pb-3">
        <Col sm={12}>
          <Table
            data={data}
            columns={columns}
            update={null}
            total_records={21}
            msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>


    </>
  );
};

export default ApproverPickupMinList;